export const isString = (myString: any): boolean => typeof myString === "string" || myString instanceof String;

export const trimString = (myString: any): any => (isString(myString) ? myString.trim() : myString);
